<template>
  <div>
    <card-toolbar
      icon="thumbs_up_down"
      :title="$tc('trust_relationship', 2)"
    >
      <template #actions>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="reloadAll">
              <v-icon outline>
                autorenew
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('reload') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn id="PermissionsPage_newPerm" icon v-on="on" @click="createPermissions()">
              <v-icon>
                add
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('new_permission') }}</span>
        </v-tooltip>
      </template>
    </card-toolbar>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row no-gutters class="pa-4">
        <v-text-field
          id="PartitionPermissionsPage_search"
          append-icon="mdi-magnify"
          :label="$tc('search')"
          single-line
          hide-details
          clearable
          v-model="search"
        />
      </v-row>
      <v-tabs
        show-arrows
        :ripple="false"
        v-model="tabActive"
        background-color="transparent"
        centered
        slider-color="dinamo"
      >
        <template v-for="(tab, key) in tabs">
          <v-tab ripple :id="`tab_${tab.id}`" :key="`tab-${key}`">
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>

      <v-tabs-items class="mt-4 mb-1" v-model="tabActive">
        <v-tab-item>
          <tab-trustees
            :search="search"
            @deletePermissionClicked="askToDeletePermissions"
            @editPermissionClicked="createPermissions"
          />
        </v-tab-item>

        <v-tab-item>
          <tab-trusters
            :search="search"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <permissions-delete-modal
      :name="selectedUser"
      :open="showPermissionsDeleteModal"
      @close="closePermissionsDeleteModal"
      @success="permissionsDeletedWithSuccess"
    />

    <confirm-modal
      :open="showPermissionsDeleteModal"
      :title="`${$tc('remove_permission')} ?`"
      :message="$tc('confirm_permission_delete')"
      :body-subject="selectedUser"
      @negative="closePermissionsDeleteModal"
      @positive="deletePermission"
    />
  </div>
</template>

<script>
import PermissionsDeleteModal from './modals/PermissionsDeleteModal'
import CardToolbar from '@/components/CardToolbar'
import ConfirmModal from '@/components/ConfirmModal.vue'
const TabTrustees = () =>
  import(/* webpackChunkName: "partition-tab-trustees" */ './tabs/TabTrustees')
const TabTrusters = () =>
  import(/* webpackChunkName: "partition-tab-trusters" */ './tabs/TabTrusters')

export default {
  components: {
    PermissionsDeleteModal,
    TabTrustees,
    TabTrusters,
    CardToolbar,
    ConfirmModal
  },
  data () {
    return {
      showPermissionsDeleteModal: false,
      tabActive: 0,
      selectedUserACL: null,
      selectedUser: null,
      search: null
    }
  },
  computed: {
    tabs () {
      return [
        {
          title: this.$t('trustees'),
          id: 'trustees'
        },
        {
          title: this.$t('trusters'),
          id: 'trusters'
        }
      ]
    }
  },
  methods: {
    reloadAll () {
      const user = this.$store.state.auth.username
      this.$store.dispatch('user/getListUserTrustees', { user })
      this.$store.dispatch('user/getListUserTrusters', { user })
    },
    // delete
    askToDeletePermissions ({ user, acl }) {
      this.showPermissionsDeleteModal = true
      this.selectedUser = user
      this.selectedUserACL = acl
    },
    closePermissionsDeleteModal () {
      this.showPermissionsDeleteModal = false
      this.selectedUser = null
      this.selectedUserACL = null
    },
    permissionsDeletedWithSuccess () {
      this.closePermissionsDeleteModal()
      this.$notify.success({})
      this.reloadAll()
    },
    deletePermission () {
      this.$store
        .dispatch('user/deletePartitionPermissions', { user: this.selectedUser })
        .then(() => {
          this.closePermissionsDeleteModal()
          this.$notify.success({})
        })
        .finally(() => this.reloadAll())
    },
    // create
    createPermissions (perm) {
      if (perm && perm.user && perm.acl !== null && perm.acl !== undefined) {
        const { user, acl } = perm
        this.reloadAll()

        this.$router.push({ name: 'edit-permission', params: { name: user, info: acl } })
      } else {
        this.$router.push({ name: 'edit-permission' })
      }
    }
  },
  watch: {
    tabActive () {
      this.search = null
    }
  }
}
</script>

<style>

.theme--light.v-tabs-items {
  background-color: transparent;
}
.theme--dark.v-tabs-items {
  background-color: transparent;
}

</style>
